@if (isProgressBarVisible()) {
    <progress-bar class="progress-bar">
    </progress-bar>
}

<div class="refresher">
    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>
    <div class="loading-bar">
    </div>
</div>

<div class="global" [class.global--sidebar-in-dom]="isChatbotVisible() && (!isSmallDevice() && !isHybrid())"
    [class.global--sidebar-right]="isSidebarOpen() && (!isSmallDevice() && !isHybrid())"
    [class.global--sidebar-collapsed]="isSidebarCollapsed()" [class.global--chat-medium]="chatbotLayout.isMedium()"
    [class.global--chat-full]="chatbotLayout.isFull()"
    [class.global--chat-listing-select]="chatbotLayout.isListingSelection()"
    [class.global--chat-resizing]="isChatResizing()">

    @if (!isSmallDevice() && !isHybrid()) {
        @if (isUserAuthorized()) {
            <toolbar class="global-toolbar">
            </toolbar>
        } @else if (isPublicPage()) {
            <public-toolbar class="global-toolbar">
            </public-toolbar>
        }
    }

    <div class="global-block" #globalBlock>

        <div class="global-content" cdkScrollable scrollToTopContainer>

            <router-outlet>
            </router-outlet>

        </div>

        @if ((isSmallDevice() || isHybrid()) && (isUserAuthorized() && isNavPanelVisible() || isPublicPage())) {
            <div class="global-bottombar-wrap">

                <navigation-panel class="global-bottombar">
                </navigation-panel>

                @if (isUserAuthorized() && !hidesChatbot()) {
                    <pnyc-button class="global-bottombar-chatbot-toggle" [iconName]="'logo-prodigy'"
                        [title]="'Chatbot'" (clicked)="onChatbotToggled()">
                    </pnyc-button>
                }

            </div>
        }

        @if (isUserAuthorized() && (!isSmallDevice() && !isHybrid()) && !isChatbotVisible() && !hidesChatbot()) {
            <pnyc-button data-testid="chatbot-toggle" class="global-chatbot-toggle" [iconName]="'logo-prodigy'"
                [title]="'Chatbot'" (clicked)="onChatbotToggled()">
            </pnyc-button>
        }

        @defer (when isChatbotVisible() && (!isSmallDevice() && !isHybrid()) && !hidesChatbot()) {
            @if (isChatbotVisible() && (!isSmallDevice() && !isHybrid()) && !hidesChatbot()) {
                @if (previewService.isOpen()) {
                    <div class="global-preview-zone" [class]="previewService.hostClasses()"
                        animate.enter="global-preview-zone--enter" animate.leave="global-preview-zone--leave">
                        <preview class="global-preview-zone-content">
                        </preview>
                    </div>
                }
                <div #sidebarZone class="global-sidebar-zone"
                    [class.global-sidebar-zone--collapsed]="isSidebarCollapsed()" (mouseenter)="onSidebarMouseEnter()"
                    (mouseleave)="onSidebarMouseLeave()">

                    <chatbot class="global-chatbot" [showAutoHide]="true" [autoHideState]="autoHideCheckboxState()"
                        (autoHideChanged)="onAutoHideChanged($event)" (closeEvent)="onSidebarClosed()">
                    </chatbot>
                </div>
            }
        }

    </div>

    <scroll-to-top />
    <toast-stack />
    <version-badge />

</div>